/**
 * Comportement des éléments du secondary header (active class au clic et au scroll)
 * @author Sandrine M'zé
 * par artwaï pour artwaï
 *
 */

const summary = {

    postTitles: [], // Eléments section-description dans l'article
    entries: [], // Eléments a du menu


    init() {
        summary.postAnchors = document.querySelectorAll('.formation-anchor');
        summary.offsetAnchor = window.innerWidth <= 1280 ? 220 : 140;
        summary.postTitles = document.querySelectorAll('.tabs .section-description');
        summary.entries = document.querySelectorAll('.secondary-menu-item');
        if (summary.postTitles.length > 0) {
            summary.handleAnchorPosition();
            summary.handlePageScroll();
        }
    },

    /**
     * Repositionnement des ancres pour scroll précis
     */
    handleAnchorPosition() {
        for (const [index, element] of summary.postTitles.entries()) {
            let anchor = element.nextElementSibling;
            // let elementTopPosition = -(summary.findRelativeParent(element).getBoundingClientRect().top - element.getBoundingClientRect().top);
            let elementTopPosition = -(summary.findRelativeParent(element).getBoundingClientRect().top - element.getBoundingClientRect().top);
            anchor.style.top = (elementTopPosition - summary.offsetAnchor) + 'px';
        }
    },

    /**
     * Trouve premie rparent qui a la position relative pour le calcul de la position de l'ancre
     */
    findRelativeParent(element, attr) {
        
        // let parent = element.closest(parentNode.attr);
        let parent = element.parentNode;
        while (parent !== null && parent.nodeType === 1) {
            let position = window.getComputedStyle(parent).position;
            if (position === "relative") {
                return parent;
            }
            parent = parent.parentNode;
        }
        return document; // Aucun parent relatif trouvé
    },
   

    /**
     * Dynamisation du menu au scroll
     */
    handlePageScroll() {
        const intersectionObserver = new IntersectionObserver(entries => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    for (let item of summary.entries) {
                        item.classList.toggle('active', item.innerText === entry.target.innerText);
                    }
                }
            }
        }, {
            root: null,

            // Option d'intersection à 80% du bas du viewport
            rootMargin: "0px 0px -60% 0px",
        });

        for (const entry of summary.postTitles) {
            intersectionObserver.observe(entry);
        }

    }
    

}

document.addEventListener('DOMContentLoaded', summary.init);